import React from 'react';
import { BentoCard } from './BentoCard';
import { Highlight } from './ui/HeroHighlight';
import { BookCallButton } from './ui/BookCallButton';
export const StatsSection = () => {
  const scrollToCalendly = () => {
    const element = document.getElementById('calendly');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return;
};